import { useService } from 'react-reservice';

import { getUseServiceWithSubscriptionKeys } from '@webtrader/core/utils';

import userPreferenceService from './service';

export const useUserPreference = () => {
  return useService(userPreferenceService, (state) => state);
};

export const useUserPreferenceWithKeys = getUseServiceWithSubscriptionKeys(userPreferenceService);

export { userPreferenceService };
